const addGWP = function(gwp_var_id) {
  // Add the gift with purchase item to the cart
  console.log('Adding gift with purchase, variant ID:', gwp_var_id);
  const product_data = {
    quantity: 1,
    id: gwp_var_id,
    properties: {'_gift_with_purchase': 'Gift with purchase!'}
  }
  fetch('/cart/add.js', {
    body: JSON.stringify(product_data),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  }).then((response) => {
    return response.json();
  }).then((json) => {
    /* yay! our products were added - trigger cart reload */
    console.log('GWP added successfully');
    const add_event = new CustomEvent('theme:cart:reload', {bubbles: true});
    document.dispatchEvent(add_event)
  }).catch((err) => {
    /* uh oh, we have error. */
    console.error('Error adding GWP:', err)
  });
}

const updateGWPQuantity = function(gwp_var_id, newQuantity) {
  // Update the GWP quantity to exactly the number specified
  console.log('Updating gift with purchase quantity to:', newQuantity);
  const update_product_data = {
    id: `${gwp_var_id}`,
    quantity: newQuantity
  }
  fetch('/cart/change.js', {
    body: JSON.stringify(update_product_data),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST'
  }).then((response) => {
    return response.json();
  }).then((json) => {
    console.log('GWP quantity updated successfully');
    const add_event = new CustomEvent('theme:cart:reload', {bubbles: true});
    document.dispatchEvent(add_event)
  }).catch((err) => {
    console.error('Error updating GWP quantity:', err)
  });
}

const removeGWP = function(gwp_var_id) {
  // Remove the gift with purchase item from the cart
  console.log('Removing gift with purchase, variant ID:', gwp_var_id);
  const remove_product_data = {
    id: `${gwp_var_id}`,
    quantity: 0
  }
  fetch('/cart/change.js', {
    body: JSON.stringify(remove_product_data),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST'
  }).then((response) => {
    return response.json();
  }).then((json) => {
    /* yay! the product was removed - trigger cart reload */
    console.log('GWP removed successfully');
    const add_event = new CustomEvent('theme:cart:reload', {bubbles: true});
    document.dispatchEvent(add_event)
  }).catch((err) => {
    /* uh oh, we have error. */
    console.error('Error removing GWP:', err)
  });
}

const check_gwp = function(cart) {
  console.log('Checking cart for GWP eligibility:', cart);
  
  // Get the eligible vendors from the HTML attribute
  const vendors_string = document.querySelector('html>body')?.dataset.eligible_vendors || '';
  // Split the comma-separated list and trim whitespace
  const eligible_vendors = vendors_string.split(',').map(vendor => vendor.trim());
  console.log('Eligible vendors:', eligible_vendors);
  
  // Get the gift variant ID from the HTML attribute
  const gwp_var_id = parseInt(document.querySelector('html>body')?.dataset.gwp_id, 10);
  
  // Get threshold from HTML attribute (converted to cents)
  let gwp_threshold = parseInt(document.querySelector('html>body')?.dataset.gwp_threshold, 10);
  gwp_threshold = gwp_threshold * 100; // Convert to cents
  
  console.log('GWP variant ID:', gwp_var_id, 'GWP threshold:', gwp_threshold);
  
  // Calculate total from eligible vendors only
  let eligible_vendors_total = 0;
  
  cart.items.forEach((item) => {
    console.log('Checking item vendor:', item.vendor, 'Price:', item.final_line_price);
    
    // Check if item is from an eligible vendor
    if (eligible_vendors.includes(item.vendor)) {
      eligible_vendors_total += item.final_line_price;
      console.log('Added to eligible total. New total:', eligible_vendors_total);
    }
  });
  
  console.log('Final eligible vendors total:', eligible_vendors_total);
  
  // Check if gift is already in the cart and get its quantity
  let hasGift = false;
  let giftQuantity = 0;
  
  cart.items.forEach((item) => {
    if (item.variant_id === gwp_var_id) {
      hasGift = true;
      giftQuantity = item.quantity;
      console.log('Gift found in cart, quantity:', giftQuantity);
    }
  });
  
  // Add, update or remove gift based on total and current cart state
  if (eligible_vendors_total >= gwp_threshold) {
    console.log('Threshold met!');
    
    if (!hasGift) {
      // Threshold is passed, and gift isn't in the cart, so add it
      console.log('Adding gift to cart');
      addGWP(gwp_var_id);
    } else if (giftQuantity !== 1) {
      // Gift is in cart but quantity is not 1, fix it
      console.log('Adjusting gift quantity to 1');
      updateGWPQuantity(gwp_var_id, 1);
    } else {
      console.log('Gift already in cart with correct quantity, no action needed');
    }
    
  } else {
    console.log('Threshold not met');
    
    if (hasGift) {
      console.log('Removing gift from cart');
      removeGWP(gwp_var_id);
    }
  }
}

// Listen for cart changes and run the check
document.addEventListener('theme:cart:change', (event) => {
  current_cart = event.detail.cart;
  console.log('Cart changed, checking GWP eligibility');
  check_gwp(current_cart);
})